var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7343 14.6664V6.13309C31.7343 5.56729 31.5095 5.02467 31.1095 4.62459C30.7094 4.22452 30.1668 3.99976 29.601 3.99976H6.13431C5.56851 3.99976 5.02589 4.22452 4.62582 4.62459C4.22574 5.02467 4.00098 5.56729 4.00098 6.13309V27.4664C4.00098 28.0322 4.22574 28.5748 4.62582 28.9749C5.02589 29.375 5.56851 29.5998 6.13431 29.5998H14.6676",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 24.2664C13.4734 24.2664 14.6673 23.0725 14.6673 21.5998C14.6673 20.127 13.4734 18.9331 12.0007 18.9331C10.5279 18.9331 9.33398 20.127 9.33398 21.5998C9.33398 23.0725 10.5279 24.2664 12.0007 24.2664Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 21.5996V11.937C14.668 11.4892 14.809 11.0528 15.0709 10.6896C15.3328 10.3263 15.7023 10.0547 16.1272 9.91322L22.5272 8.13544C22.8478 8.02864 23.1893 7.99955 23.5234 8.05057C23.8575 8.10159 24.1747 8.23126 24.4488 8.4289C24.723 8.62653 24.9463 8.88648 25.1003 9.18732C25.2543 9.48816 25.3346 9.82129 25.3346 10.1593V14.6663",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4669 35.9998C32.1798 35.9998 36.0003 32.1793 36.0003 27.4664C36.0003 22.7536 32.1798 18.9331 27.4669 18.9331C22.7541 18.9331 18.9336 22.7536 18.9336 27.4664C18.9336 32.1793 22.7541 35.9998 27.4669 35.9998Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23.9998V27.7498L30 29.9998",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreRelease);
export default __webpack_public_path__ + "static/media/pre-release.1a8ad256.svg";
export { ForwardRef as ReactComponent };